import { validSearchFieldNames } from '../../Settings/config';

const escapeSearchValue = (str: string): string => {
  const chars: string[] = ['+', '&', '|', '!', '(', ')', '{', '}', '[', ']', '^', '~', '*', '?', ':', '\\\\', '/'];
  return ([].map.call(str, (char: string): string => chars.includes(char) ? `\\${char}` : char) as string[]).join('');
};

export const escapeSearchQuery = (str: string): string => {
  const fieldName: string | undefined = validSearchFieldNames.find(
    (validFieldName: string): boolean =>
      str.startsWith(`${validFieldName}:`) && !/\s/.test(str.charAt(validFieldName.length + 1)),
  );

  if (fieldName) {
    return `${fieldName}:${escapeSearchValue(str.slice(fieldName.length + 1))}`;
  }

  return escapeSearchValue(str);
};